import React from 'react';
import { UiIcon } from 'ui-components';
import { useTranslation } from 'react-i18next';
import { StyledNetworkStatusBanner } from './NetworkStatusBanner.styles';

function NetworkStatusBanner() {
  const { t } = useTranslation();
  return (
    <StyledNetworkStatusBanner>
      <div className='alert'>
        <UiIcon icon='ri-wifi-off-line' size={16} color='primary' />
        <span>{t('error:noNetwork')}</span>
      </div>
      <span className='description'>{t('error:refreshPage')}</span>
    </StyledNetworkStatusBanner>
  );
}

export default NetworkStatusBanner;
